type ScriptOptions = Partial<HTMLScriptElement> &
	(
		| {
				src?: never
				textContent: string
		  }
		| {
				src: string
				textContent?: never
		  }
	)

export function addScriptOn(target: HTMLElement, scriptOpts: ScriptOptions): Promise<() => void> {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script')

		Object.assign(script, scriptOpts)

		if (scriptOpts.src) {
			script.async = scriptOpts.async ?? true
			script.onload = ev => {
				scriptOpts.onload?.call(script, ev)
				resolve(cleanup)
			}
			script.onerror = error => {
				scriptOpts.onerror?.call(script, error)
				reject(error)
			}
		}

		target.appendChild(script)

		// Resolve the promise if the script has text content
		if (scriptOpts.textContent) {
			resolve(cleanup)
		}

		function cleanup() {
			target.removeChild(script)
		}
	})
}
